module.exports = __webpack_public_path__ + "img/the-thinking-traveller-logo-light.db2b764c.svg";